import type { AppModuleId } from '../../config/appNavigation'
import type { FolderSchema } from './api/contracts'

/**
 * What the rail can open a menu for: an area, or Favorites (a shortcut beside
 * Home with a menu of its own, not an area).
 */
export type ActiveModule = AppModuleId | typeof FAVORITES_RAIL_ITEM

export const FAVORITES_RAIL_ITEM = 'favorites'

/** The rail's Search item: it opens the sidebar's search (SidebarSearch), not a menu. */
export const SEARCH_RAIL_ITEM = 'search'

export interface FolderNode extends FolderSchema {
  children: FolderNode[]
}
